import React, { useState, useEffect } from "react";
import { green, grey } from '@mui/material/colors';
import { Avatar, Switch } from "@mui/material";
import {io} from "socket.io-client";

const ENDPOINT = "wss://emisor.iotfera.ovh";
//const ENDPOINT = "ws://localhost:20001";
var socketIo;

function App() {

    const [response, setResponse] = useState("");
    const [msg, setMsg] = useState("");
    const [checked, setChecked] = useState(false);
    const [connected, setConnected] = useState(false);
    const [token, setToken] = useState(false);


    const removeListeners = () => {
        if (socketIo) {
            socketIo.removeAllListeners("hello");
            socketIo.removeAllListeners("switch");
            socketIo.removeAllListeners("disconnect");
        }  
    }

    const clearMsg = () => {
        setMsg("");
    }

    const connect = () => {
        if (!token) return;
       socketIo = io(ENDPOINT,  {
            transportOptions: {
                transports: ["websocket"]
                ,protocols: ["my-protocol-v1"]               
            }
            ,auth: {
                token: token
            }
            
        });

        socketIo.on("connect_error", (err) => {
            setConnected(false);
            console.log(err instanceof Error); // true
            console.log(err.message); // not authorized
            console.log(err.data); // { content: "Please retry later" }
            removeListeners();
        });

        socketIo.on("connect", (socket) => {

            console.log("Conectado a IO");

            setConnected(true);
            console.log('Client IO Connected: ', socketIo.id);

            socketIo.on("hello", (arg, callback) => {
                console.log(arg); // "world"
                //callback("got it");
            });
            socketIo.on("switch", (arg, callback) => {
                setResponse(arg);
                switch (arg) {
                    case '1': 
                        setChecked(true);
                        break;
                    case '0':
                        setChecked(false);
                        break;
                    default:
                }
                console.log("Received: '" + arg + "'");
            });
            socketIo.on("disconnect", (reason) => {
                removeListeners();
                if (reason === "io server disconnect") {
                    // the disconnection was initiated by the server, you need to reconnect manually
                    socket.connect();
                }
                
                // else the socket will automatically try to reconnect
            });
        });
    }

    const onChange = (e) => {
        const t = e.target.value;
        setToken(t);
    }

    const handleChange = (e) => {
        const t = e.target.checked;
        if (connected){
            if(socketIo.active){
                setChecked(t);
                socketIo.emit("switch", t ? '1' : '0')
                console.log("emit:", t ? '1' : '0')
            }
            else{
                setChecked(!t);
            }
        }
    }

    const sendtoken = () => {
        if (socketIo){
            if (!socketIo.connected){
                console.log(token)
                removeListeners();
                connect();
            }
            else{
                setMsg("Socket ya conectado");
                setTimeout(clearMsg, 3000);
            }
        }
        else{
            console.log(token)
            removeListeners();
            connect();
        }
    }

    return (
        <div>
            <Avatar sx={{ bgcolor: connected ? green[500] :  grey[500]}}>C</Avatar>
        It's <time dateTime={response}>{response}</time>&nbsp;<br/>
        Token:&nbsp;<input type="text" onChange={onChange}></input>
        <button onClick={sendtoken}>Conectar</button>
        <div>{msg}</div>
        <Switch
            checked={checked}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
            />
        </div>
    );
}

export default App;